import { QueryClient, useQueryClient } from "@tanstack/react-query";
import { usePrevious } from "../../../../../hooks/usePrevious";
import { queryKeyEqual } from "../helpers/queryKeyEqual";
import { useEvent } from "../../../../../hooks/useEvent";
import { useLayoutEffect, useRef } from "react";


export const useUpdateOnUnmount = <T>(queryKey: any[], getUpdatedData: () => Promise<T>, updateCache: (data: T, queryClient: QueryClient) => void) => {
    const prevQueryKey = usePrevious(queryKey, false);
    const queryClient = useQueryClient();
    const getUpdatedDataRef = useRef(getUpdatedData);
    
    // Keep the ref updated with the latest function
    getUpdatedDataRef.current = getUpdatedData;
    
    const updateQueryCache = useEvent((data: T) => {
        return updateCache(data, queryClient);
    });

    useLayoutEffect(() => {
        const updater = updateQueryCache;
        if (prevQueryKey && queryKeyEqual(queryKey, prevQueryKey)) {
            // Only run the cleanup function when the component unmounts or queryKey changes
            return () => {
                getUpdatedDataRef.current().then(updater);
            };
        }
    }, [prevQueryKey, queryKey, updateQueryCache]);
};